import { render } from "./Calendar.vue?vue&type=template&id=70e10d6c&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=70e10d6c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70e10d6c"

export default script